import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export const clearPolylinesQueue = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/clearPolylinesQueue', async (_payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/route/clearPolylinesQueue', {
      category: 'rpc',
      type: 'rpc/route/clearPolylinesQueue',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {clearPolylinesQueue}`,
      { tags: ['rpc', 'order'], info: { error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `ClearPolylinesQueue failed`,
      error,
    })
  }
})
